import withStyles from '@mui/styles/withStyles';
import { withRouter } from 'react-router-dom';
import { Dispatch, Action } from 'redux';
import i18next from 'i18next';
import { getDefaultTableProperties, DataService } from '../../../services';
import { SubdomainRoutePath, ModalVariants, DeviceApiGw } from '../../../common/types';
import { connect } from 'react-redux';
import { storeOpenModal } from '../../../store/actions/modal';
import { tableProperties, itemIcons, TableNames } from '../../../common/constants';
import { SnackbarUtils } from '../../../components';
import { ListBase, ListBaseStyles, ListBaseProps, ListBaseState } from '../../baseClasses/ListBase';

type _Props = {
  openModal: (callback: () => any) => void;
};
type Props = ListBaseProps<_Props>;

type State = ListBaseState;

class DeviceApiGwView extends ListBase<_Props> {
  state: State = {
    initLoaded: false,
    loading: false,
    items: [],
    activeTabIndex: 0,
    predefinedFilters: [],
    properties: [],
  };

  constructor(props: Props) {
    super(props);
    // Init static variables
    this.accessControlSection = 'deviceApiGw';
    this.title = i18next.t('deviceApiGws');
    this.icon = itemIcons.deviceApiGw;
    this.idKey = 'apiId';
    this.tableConfig = {
      tableProperties: getDefaultTableProperties(tableProperties(TableNames.deviceApiGw)),
      emptyTitle: 'form.empty.deviceApiGw',
      rowActions: [
        {
          title: '',
          dynamicTitle: (api: DeviceApiGw) => (api.enabled ? 'action.disable' : 'action.enable'),
          action: async (api: DeviceApiGw) => await this.toggleEnabledApi(api.apiId),
        },
        {
          title: 'action.delete',
          action: async (api: DeviceApiGw) => this.setState({ dialogOpen: api.apiId }),
        },
      ],
    };
    this.dialogConfig = {
      title: i18next.t('action.delete'),
      description: i18next.t('description.delete.deviceApiGw'),
      continueTitle: i18next.t('action.delete'),
      onClose: () => this.setState({ dialogOpen: undefined }),
      onContinue: () => this.state.dialogOpen && this.removeApi(this.state.dialogOpen),
    };
    this.fabConfig = [
      {
        title: i18next.t('action.createDeviceApiGw'),
        action: () => this.props.openModal(this.reloadList),
        icon: itemIcons.deviceApiGw,
        tryAccessRight: ['deviceApiGw', 'create'],
      },
    ];

    // Functions
    this.getUrlPathForItem = SubdomainRoutePath.deviceApiGw;
  }

  componentDidMount = async () => {
    this.service = await DataService.create();
    this.list = this.service!.deviceApiGw.list;
    this.setState({ initLoaded: true });
  };

  toggleEnabledApi = async (api: string): Promise<void> => {
    try {
      this.setState({ loading: true });
      const itemToEdit = this.state.items.find((item) => item.apiId === api);
      if (itemToEdit && !this.isUnmounted) {
        await this.service.deviceApiGw.put(api, { enabled: !itemToEdit?.enabled });
        this.state.items = [];
        await this.loadData();
        SnackbarUtils.success(i18next.t('success.update.subscription'));
        if (!this.isUnmounted) this.setState({ loading: false });
      } else {
        SnackbarUtils.error(i18next.t('error.tryAgain'));
      }
    } catch (e) {
      const error: any = e;
      SnackbarUtils.error(
        (error.response && error.response.data && error.response.data.message) || i18next.t('error.tryAgain'),
      );
      if (!this.isUnmounted) this.setState({ loading: false });
    }
  };

  removeApi = async (api: string): Promise<void> => {
    try {
      await this.service.deviceApiGw.del(api);
      SnackbarUtils.success(i18next.t('success.delete.deviceApiGw'));
      if (!this.isUnmounted) {
        const items = this.state.items.filter((a: DeviceApiGw) => a.apiId !== api);
        this.setState({ items });
      }
    } catch (e) {
      const error: any = e;
      SnackbarUtils.error(
        (error.response && error.response.data && error.response.data.message) || i18next.t('error.tryAgain'),
      );
      if (!this.isUnmounted) this.setState({ loading: false });
    }
  };
}
const mapDispatchToProps = (dispatch: Dispatch<Action>) => ({
  openModal: (callback: () => any) => dispatch(storeOpenModal(ModalVariants.CreateDeviceApiGwMC, { callback })),
});

export default withStyles(ListBaseStyles)(withRouter(connect(null, mapDispatchToProps)(DeviceApiGwView)));
